import React, { useEffect, useState } from "react";
import DashboardShell from "../../components/layout/DashboardShell";
import { Card, EmptyState } from "../../components/common/Primitives";
import api from "../../lib/api";

export default function StartupMatches() {
  const [matches, setMatches] = useState([]);
  useEffect(() => { api.get("/startup/matches").then((r) => setMatches(r.data || [])); }, []);

  return (
    <DashboardShell title="Investor Matches" subtitle="RULE-BASED · WEIGHTED">
      {matches.length === 0 ? (
        <EmptyState title="No matches yet" hint="Approved investors matching your sector/stage/ticket-size will appear here." />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {matches.map((m) => (
            <Card key={m.investor_id} testId={`match-${m.investor_id}`}>
              <div className="flex justify-between items-start">
                <div>
                  <div className="font-heading text-ink text-lg">{m.investor_name}</div>
                  <div className="text-xs text-ink-muted font-mono uppercase tracking-wider mt-1">{m.investor_type} · {m.city}</div>
                </div>
                <div className="match-badge px-2.5 py-1 text-[11px] font-mono">{m.match_score}</div>
              </div>
              <div className="mt-4 grid grid-cols-2 gap-3 text-sm">
                <div><div className="overline">Ticket Min</div><div className="text-ink font-mono mt-0.5">₹{((m.ticket_size_min || 0) / 1e5).toFixed(0)}L</div></div>
                <div><div className="overline">Ticket Max</div><div className="text-ink font-mono mt-0.5">₹{((m.ticket_size_max || 0) / 1e7).toFixed(1)}Cr</div></div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </DashboardShell>
  );
}
